export enum ExportPowerBIReportFileFormat {
  PPTX,
  PDF,
  PNG
}
